module.exports = __webpack_public_path__ + "static/media/varais-10-copia.f42500db.jpg";